module.exports = __webpack_public_path__ + "static/media/EndUser.48e95760.png";